import React from 'react'
import SearchWidget from 'components/Flights/FlightsSearch/SearchWidget/SearchWidget'

function GlobalFlightsSearchTabContent() {
  return <SearchWidget />
}

export default GlobalFlightsSearchTabContent
